module.exports = __webpack_public_path__ + "static/media/display-4.8ef3c09a.png";